

const getters = {
  getFundInfoData: state => state.fundInfoData,
  trademarkType: state => state.fundInfoData.trademarkType,
  fundAvailableShareClasses: state => state.fundInfoData.fundAvailableShareClasses
};

const mutations = {
  SET_FUND_INFO(state, payload) {
    state.fundInfoData = {
      fundAbbreviation: payload.AbbreviatedClassName,
      cgIndexName: payload.CGIndexName,
      cgIndexID: payload.CGIndexID,
      trademarkType: payload.TrademarkType,
      trademarkLegal: payload.TrademarkLegal,
      trademarkShort: payload.TrademarkShort,
      fundAvailableShareClasses: payload.availableShareClasses
    };
  }
};

const state = {
  fundInfoData: {}
};

export default {
  getters,
  mutations,
  state
};
